import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SearchParams } from "src/app/shared/model/searchParams";
import { UrlUtilService } from "src/app/shared/service/url-util/url-util.service";

import { CommercialRolesRequest } from "../model/sales-choose.model";
import { endpoints } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class SalesChooseService {
  private commercial_roles_url = endpoints.commercial_roles;
  private commercial_roles_export = endpoints.commercial_roles_export;
  constructor(private http: HttpClient, private urlService: UrlUtilService) {}

  commercialRoles(searchParams: SearchParams, body: CommercialRolesRequest) {
    return this.http.post(
      `${
        this.commercial_roles_url
      }?${this.urlService.convertObjectToSearchParam(searchParams)}`,
      body
    );
  }

  commercialRolesExport(searchParams: SearchParams, body: CommercialRolesRequest) {
    return this.http.post(
      `${
        this.commercial_roles_export
      }?${this.urlService.convertObjectToSearchParam(searchParams)}`,
      body,
      { responseType: "blob" as "json",
        headers: this.urlService.getDefaultHeaders()
      }
    );
  }
}
